<template>
  <button @click="showCart()" class="flex items-center group relative uppercase">
    <!--    <img class="w-6 -scale-x-100" src="/img/cart.svg" alt="Cart"/>-->

    <span class="group-hover:underline">Cart
      <span class="text-[16px]" v-if="quantity != 0">({{ quantity }})</span>
    </span>
  </button>
</template>

<script setup>
import Client from 'shopify-buy';
import { ref, onMounted, watch, computed } from 'vue';
import { inject } from 'vue'

const emitter = inject('emitter');   // Inject `emitter`

const quantity = ref(0);
const showCart = () => {
  emitter.emit('showCart');
}

emitter.on('quantityUpdate', (value) => {   // *Listen* for event
  quantity.value = value.value;
  console.log(quantity.value);
});



</script>